import { isMobile } from 'Helpers/devices';
import { VALUATION_FLOW_ROUTE, SELL_OLD_CAR_ROUTE } from '../../olxautos/constants/layout';

export const renderHeadTitle = (displayFields, apiParam, userDataValues) => {
    let title = 'Sell Your ';
    const index = displayFields.findIndex(field => field.id === apiParam);
    const takenDisplayField = displayFields.slice(0, index + 1);

    for (let i = 0; i < takenDisplayField.length; i++) {
        const { id } = takenDisplayField[i];

        if (userDataValues[id]) {
            const displayValue = `${id}-displayValue`;

            title = `${title} ${userDataValues[displayValue]} `;
        }
    }

    title = `${title} Car Instantly`;

    return title;
};

export const makeNavigationUrl = (currentList, id, displayFields, userDataValues, marketConfig) => {
    /**
     * Only make link for in
     */
    if (!marketConfig?.get('olxAutos', 'isHandleSeoLink')) {
        return null;
    }

    let pathname = isMobile ? `${VALUATION_FLOW_ROUTE}/${SELL_OLD_CAR_ROUTE}` : `/${SELL_OLD_CAR_ROUTE}`;
    let query = '';
    const apiKey = id;

    const index = displayFields.findIndex(field => field.id === id);
    const takenDisplayField = displayFields.slice(0, index + 1);

    for (let i = 0; i < takenDisplayField.length; i++) {
        const { id } = takenDisplayField[i];

        if (id === apiKey) {
            pathname = `${pathname}/${currentList.key}`;
            query = query ? `${query}&${id}=${currentList.label}` : `${id}=${currentList.label}`;
        }
        else if (userDataValues[id]) {
            const displayValue = `${id}-displayValue`;

            pathname = `${pathname}/${userDataValues[id]}`;
            query = query ? `${query}&${id}=${userDataValues[displayValue]}` : `${id}=${userDataValues[displayValue]}`;
        }
    }

    return `${pathname}/car?${query}`;
};

export const manipulateCarData = (state, data) => {
    const displayFields = state.valuationFormFields;
    let lastSelectedIdx = 0;
    const userData = {};

    for (let i = 0; i < displayFields.length; i++) {
        const key = displayFields[i].id;

        if (data[key] === undefined) {
            lastSelectedIdx = i;
            break;
        }
        else {
            userData[key] = data[key];
            userData[`${key}-displayValue`] = data[`${key}Value`];
        }
    }

    return {
        lastSelectedIdx,
        userData,
        lastSelectionOption: displayFields[lastSelectedIdx]?.id,
        toggleSubMenu: true
    };
};
